import {
  NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION,
  NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE,
  NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION,
  NEW_FEATURE_CALLOUT_INSIGHTS_TITLE,
} from "../../i18n/keysTranslations";

/**
 * @typedef {Object} NewFeatureCatalogItem
 * @property {string} id
 * @property {"right" | "left" | "top" | "bottom"} [placement]
 * @property {boolean} enabled
 * @property {string} titleKey
 * @property {string} descriptionKey
 * @property {string} [ctaKey]
 * @property {number} [priority] - Higher wins when multiple features are eligible
 */

/**
 * Single source of truth. Set `enabled: true` and add i18n keys to activate.
 *
 * @type {NewFeatureCatalogItem[]}
 */
export const NEW_FEATURES = [
  {
    id: "insights",
    enabled: true,
    placement: "right",
    titleKey: NEW_FEATURE_CALLOUT_INSIGHTS_TITLE,
    descriptionKey: NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION,
    priority: 10,
  },
  {
    id: "gallery-templates",
    enabled: true,
    placement: "bottom",
    titleKey: NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE,
    descriptionKey: NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION,
    priority: 20,
  },
  {
    id: "automations",
    enabled: true,
    placement: "right",
    titleKey: NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE,
    descriptionKey: NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION,
    priority: 30,
  },
];

/**
 * @param {string} featureId
 * @returns {NewFeatureCatalogItem | null}
 */
export const getNewFeatureById = (featureId) =>
  NEW_FEATURES.find((item) => item.id === featureId) ?? null;

/**
 * @param {string} featureId
 * @returns {boolean}
 */
export const isKnownNewFeatureId = (featureId) =>
  Boolean(featureId && getNewFeatureById(featureId));
